import "./public-path";
import "./appEvents/events";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import RestAPIClient from "services/RestAPIClient";
import authService from "pages/Auth/services/authService";
import { isBSP, isMicroApp } from "utils/microApp";
import { appConfigService } from "services/appConfigService";
import scService from "pages/Seller/services/scService";
import i18n from "i18next";
import eventService, { AppEvent } from "appEvents";
import { setMicroAppData } from "appEvents/events/microApp";

Sentry.init({
  enabled: process.env.NODE_ENV !== "development",
  dsn: process.env.SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.2,
  autoSessionTracking: false,
  ignoreErrors: [
    "ResizeObserver",
    "ResizeObserver loop limit exceeded",
    "ChunkLoadError",
  ],
});

export async function bootstrap() {
  console.log("react app bootstraped");
}

export async function mount(props?: any) {
  if (isMicroApp) {
    setMicroAppData(props);
    eventService.emit(AppEvent.UPDATE_MICRO_APP_PROPS, props);

    let accessToken;
    let locale;

    if (!isBSP) {
      accessToken = props?.scData?.accessToken;
      locale = props?.scData?.locale;
      const sellerId = props?.scData?.user?.currentSellerId;
      RestAPIClient.seller_id = sellerId;

      scService.setCurrentUser(props?.scData?.user);
    } else {
      accessToken = props?.bspData?.accessToken;
      locale = props?.bspData?.locale;
    }

    RestAPIClient.token = accessToken;

    const lang = locale === "vi-VN" ? "vi" : "en";

    appConfigService.setItem("lang", lang);

    i18n.changeLanguage(lang);
  }

  ReactDOM.render(
    <App />,
    props?.container
      ? props?.container?.querySelector("#root")
      : document.getElementById("root")
  );
}

export async function unmount(props) {
  eventService.emit(AppEvent.UPDATE_MICRO_APP_PROPS, undefined);
  ReactDOM.unmountComponentAtNode(
    props.container
      ? props.container.querySelector("#root")
      : document.getElementById("root")
  );
}

export async function update(props) {
  if (isMicroApp) {
    eventService.emit(AppEvent.UPDATE_MICRO_APP_PROPS, props);
    const accessToken = props?.scData?.accessToken;
    const locale = props?.scData?.locale;

    RestAPIClient.token = accessToken;
    // RestAPIClient.seller_id = sellerId;
    appConfigService.setItem("lang", locale === "vi-VN" ? "vi" : "en");
  }
}

if (!window.__POWERED_BY_QIANKUN__) {
  console.log(window.__POWERED_BY_QIANKUN__);
  mount();
}
